import {TimeLogger} from './logger';

type Options = {
    appendId?: string;
};

export const copyToClipboard = async (text: string, options?: Options): Promise<boolean> => {
    if (window.internalAPI?.copyTextToClipboard) {
        window.internalAPI.copyTextToClipboard(text);
        return true;
    }

    const clipboard = navigator.clipboard;

    try {
        await clipboard.writeText(text);
        return true;
    } catch (error) {
        TimeLogger.error(`Can not copy text to clipboard due to: ${error}`);
    }

    const textField = document.createElement('textarea');

    textField.value = text;
    textField.style.position = 'fixed';
    textField.style.opacity = '0';

    if (options?.appendId) {
        document.getElementById(options.appendId)?.append(textField);
    } else {
        document.body.append(textField);
    }

    textField.focus();
    textField.select();

    try {
        return document.execCommand('copy');
    } catch (error) {
        TimeLogger.error(`Can not copy text to clipboard due to: ${error}`);
        return false;
    } finally {
        textField.remove();
    }
};
